@let vm = vm$();

<div class="h-100 w-100">
  <div class="flex-col start-start gap-24 ui-tab custom-events-wrapper">
    @if (vm.viewState !== 'LOADING' && vm.viewState !== 'INITIAL_EMPTY') {
      <div class="flex-col gap-16">
        <ui-search
          style="width: 320px"
          [placeholder]="'PENDING_INVITATIONS_MODAL.SEARCH'|translate"
          [searchQuery]="vm.search"
          (onInput)="search.set($event)">
        </ui-search>
      </div>
    }

    @switch (vm.viewState) {
      @case ('LOADING') {
        <div class="h-100 w-100 flex-col center-center">
          <ui-preloader [color]="PreloaderColor.blue"></ui-preloader>
        </div>
      }
      @case ('INITIAL_EMPTY') {
        <div class="h-100 w-100 flex-col center-center">
          <ui-no-data
            [imgSrc]="noData.imgSrc"
            [title]="noData.title | translate"
            [createButtonText]="noData.createButtonText | translate"
            (onCreate)="createEventType()">
          </ui-no-data>
        </div>
      }
      @case ('NO_RESULTS') {
        <div class="h-100 w-100 flex-col center-center">
          <ui-no-data
            [imgSrc]="noResults.imgSrc"
            [title]="noResults.title | translate">
          </ui-no-data>
        </div>
      }
      @case ('HAS_DATA') {
        <div class="mb-8">{{ 'CUSTOM_EVENTS.LIMIT'|translate:{selected: vm.allEvents.length} }}</div>
        @if (tableConfig()) {
          <ui-dataset-table
            [data]="vm.filteredEvents"
            [config]="tableConfig()!"
            (rowAction)="onRowAction($event)"
          ></ui-dataset-table>
        }
      }
    }
  </div>
</div>
